import { css, SerializedStyles } from '@emotion/react';
import { Theme, useTheme } from '@mui/material';

export const useBreadcrumbsComponentStyles = (): SerializedStyles => {
  const theme = useTheme<Theme>();

  return css`
    display: flex;
    padding-bottom: ${theme.spacing(3)};

    .breadcrumb-item {
      display: flex;
      align-items: center;
    }

    .breadcrumb-link {
      font-weight: normal;
      color: ${theme.palette.common.black};
    }
  `;
};
